module.exports = __webpack_public_path__ + "static/media/recruit_780_default.94d2ff68.png";